import { useDropdownState } from '../abstract/dropdown';

export function useFloorSizeFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { selected: floorSize, onSelect: onFloorSizeSelect, options: floorSizeOptions } = useDropdownState({
    defaultOptions: config.buildingSizeOptions,
    defaultValue: query.buildingSize || config.buildingSizeDefault,
    filterKey: `buildingSize`,
    queryKey: `building`,
    setFilters,
    updateQuery,
  });

  return { floorSize, floorSizeOptions, onFloorSizeSelect };
}
